import {TFilter, TList, TResponse} from '@/types';
import CancelablePromise from 'mn-utils/CancelablePromise';

import {TListItem, TCreateParams} from './types';

import {apiRequest} from '../../ws';
import {get, post} from '../../http';
import {getReferralMerchantsList} from './mock';

import {
  ENDPOINT_REF_MERCH_LIST,
  ENDPOINT_REF_MERCH_REG
} from '../../../constants/api';

export function apiV2ReferralMerchantsList(params: TFilter<TListItem>): Promise<TList<TListItem>> {
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;
  const url = ENDPOINT_REF_MERCH_LIST;

  if (process.env.MOCK) {
    const response = {
      list: getReferralMerchantsList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return get(url, params).then(res => {
    console.log(url, res);
    return res;
  });
}

export function apiV2ReferralMerchantsAdd(params: TCreateParams): Promise<TResponse> {
  const url = ENDPOINT_REF_MERCH_REG;
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return post(url, params);
}
